import { css } from "@emotion/css";
import React from "react";

import { Link } from "../../link/Link";

export interface InnerContentLinkProps {
  children: React.ReactNode;
  onPress?: () => void;
  url?: string;
  testID?: string;
}

export function InnerContentLink(props: InnerContentLinkProps) {
  const { onPress, url, children, testID = "inner-content-link" } = props;

  return (
    <div className={css(styles.innerContentItem)}>
      <div className={css(styles.innerContentLinkWrapper)}>
        <Link
          linkStyle="monochrome"
          href={url}
          onPress={onPress}
          textStyle="global/body-secondary"
          textColor="text-weak"
          testID={testID}
        >
          {children}
        </Link>
      </div>
    </div>
  );
}

const styles = {
  innerContentItem: css({
    marginTop: "var(--space-4)",
    marginBottom: "var(--space-4)",
    paddingRight: "var(--space-4)",
    paddingLeft: "var(--space-4)",
  }),
  innerContentLinkWrapper: css({
    paddingTop: "var(--space-1)",
    paddingBottom: "var(--space-1)",
    marginTop: "var(--space-4)",
  }),
};
